<template>
  <li class="item">
    <div class="form-group form checkox-input item-name">
      <input :id="'result-' + itemID" type="checkbox" autocomplete="off" v-model="itemsSelected" :value="result" v-on:change="selectHandler()" />
      <label :for="'result-' + itemID" v-html="result.Title"></label>
    </div>
    <div class="item-date">{{ formatDate(result.OrderStartDate) }} - {{ formatDate(result.OrderEndDate) }}</div>
  </li>
</template>

<script>
import DateFormatService from '../../common/date-format.service';

export default {
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    selectedspecials: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      itemID: null,
      listActionsStuck: false,
      itemsSelected: [],
      itemValue: ''
    };
  },
  watch: {
    selectedspecials: {
      handler(newVal) {
        this.itemsSelected = newVal;
      },
      deep: true
    }
  },
  mounted() {
    this.itemID = this._uid;
    this.$parent.clearCookie('selectedSpecials');

    this.itemsSelected = this.selectedspecials;
    this.stickListActions();

    if (this.result.NodeID === 0) {
      this.itemValue = this.result.LmcSpecialID;
    } else {
      this.itemValue = this.result.NodeID;
    }

    $(window).on('scroll', (e) => {
      this.stickListActions();
    });
  },
  methods: {
    formatDate: function(date) {
      return DateFormatService.customFormatter(date, 'full-slash');
    },

    unselectSelectAll() {
      this.$emit('unselectselectall');
    },
    selectSingle() {
      this.$emit('selectsinglespecial', this.result);
    },
    selectHandler() {
      this.unselectSelectAll();
      this.selectSingle();
    },
    stickListActions() {
      let $stickyElem = $('.js-list-actions');
      let $stickyParent = $('.js-specials-list');
      let parentOffset = Math.round($stickyParent.offset().top);
      let parentHeight = $stickyParent.outerHeight();
      let parentWidth = $stickyParent.width();
      let stickyHeight = $stickyElem.outerHeight();
      let viewHeight = $(window).height();
      let totalHeight = parentHeight + stickyHeight * 2;

      $stickyElem.width(parentWidth);

      let offset = parentOffset + parentHeight + stickyHeight / 2 - $(window).scrollTop();

      if (offset <= viewHeight && !this.listActionsStuck) {
        this.listActionsStuck = true;
        $stickyElem.addClass('static');
      }
      if (offset > viewHeight && this.listActionsStuck) {
        this.listActionsStuck = false;
        $stickyElem.removeClass('static');
      }
    }
  }
};
</script>
